import { render, staticRenderFns } from "./Facilities20.vue?vue&type=template&id=27fbca5e&"
import script from "./Facilities20.vue?vue&type=script&lang=js&"
export * from "./Facilities20.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports